import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../../common';
export var cardSectionKey = 'card-section';
var CardSection = /** @class */ (function (_super) {
    __extends(CardSection, _super);
    function CardSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardSection.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames(cardSectionKey, props.className);
        return (React.createElement("div", { className: classNames }, props.children));
    };
    return CardSection;
}(React.PureComponent));
export { CardSection };
//# sourceMappingURL=index.js.map